// extracted by mini-css-extract-plugin
module.exports = {"page":"kbUWp","additionalText":"t5-lS"};